import axios from 'axios'
import {
  GET_CLIENTS_COUNT,
  GET_CLIENTS_LIST,
  GET_CLIENT,
  UPDATE_CLIENT_SAVE,
  UPDATE_CLIENT_SAVE_AND_CLOSE,
  TRANSFER_CLIENT,
  CLIENT_CHANGE_PROGRAM
} from './action-constants'

const TABLENAME = 'clients'
const TABLENAME_BY_LOGIN_ID =
  'clients/bylogin' /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME_CLIENT_TRANSFER = 'clients/transfer'
const TABLENAME_CLIENT_COUNT = 'clients/count'
const TABLENAME_CLIENT_CHANGE_PROGRAM = 'clients/changeprogram'

export function getClientsCount (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_CLIENT_COUNT + '/' + loginID
  return {
    type: GET_CLIENTS_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getClientsList (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_BY_LOGIN_ID + '/' + loginID
  return {
    type: GET_CLIENTS_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getClient (id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/CLIENTs/' + id
  return {
    type: GET_CLIENT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function updateClientSaveAndClose (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: UPDATE_CLIENT_SAVE_AND_CLOSE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function updateClientSave (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: UPDATE_CLIENT_SAVE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function changeProgram (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_CLIENT_CHANGE_PROGRAM + '/' + id
  return {
    type: CLIENT_CHANGE_PROGRAM,
    payload: new Promise((resolve, reject) => {
      axios
        .post(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function transferClient (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_CLIENT_TRANSFER + '/' + id
  return {
    type: TRANSFER_CLIENT,
    payload: new Promise((resolve, reject) => {
      axios
        .post(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
